import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface WebhookLog {
  id: string;
  webhook_config_id: string | null;
  webhook_name: string;
  event_type: string | null;
  status: string;
  request_payload: Record<string, any> | null;
  response_payload: Record<string, any> | null;
  error_message: string | null;
  processing_time_ms: number | null;
  contact_id: string | null;
  deal_id: string | null;
  is_new_contact: boolean | null;
  is_new_deal: boolean | null;
  assigned_user_id: string | null;
  ip_address: string | null;
  user_agent: string | null;
  is_dry_run: boolean | null;
  created_at: string;
}

export interface WebhookLogsFilters {
  webhookName?: string;
  status?: string;
  isDryRun?: boolean;
  limit?: number;
}

export function useWebhookLogs(filters: WebhookLogsFilters = {}) {
  const { webhookName, status, isDryRun, limit = 100 } = filters;
  
  return useQuery({
    queryKey: ['webhook-logs', filters],
    queryFn: async () => {
      let query = supabase
        .from('webhook_logs')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(limit);
      
      if (webhookName) {
        query = query.eq('webhook_name', webhookName);
      }
      if (status) {
        query = query.eq('status', status);
      }
      if (isDryRun !== undefined) {
        query = query.eq('is_dry_run', isDryRun);
      }
      
      const { data, error } = await query;
      if (error) throw error;
      return data as WebhookLog[];
    },
    refetchInterval: 30000, // Auto-refresh every 30s
  });
}
